/**
 * Campaign page enhancements.
 */

const initTeamFilters = () => {
		document.querySelectorAll( '.campaign-participants' ).forEach( ( section ) => {
			const pillContainer = section.querySelector( '.campaign-team-pills' );
			const teamPills = Array.from( section.querySelectorAll( '.campaign-team-pill a' ) );
			const teamGroups = Array.from( section.querySelectorAll( '.campaign-team-group' ) );
			const populatedTeamGroups = teamGroups.filter( ( group ) => group.querySelector( '.campaign-participant-card' ) );

		if ( ! pillContainer ) {
			return;
		}

			if ( teamPills.length < 2 || populatedTeamGroups.length < 2 ) {
			pillContainer.hidden = true;
			return;
		}

		pillContainer.classList.add( 'is-visible' );

		let activeIndex = null;

		const setFilter = ( nextIndex = null ) => {
			activeIndex = nextIndex;

			teamGroups.forEach( ( group, index ) => {
				group.classList.toggle( 'is-filtered-out', null !== activeIndex && index !== activeIndex );
				group.classList.toggle( 'is-active', null !== activeIndex && index === activeIndex );
			} );

			teamPills.forEach( ( pill, index ) => {
				pill.parentElement.classList.toggle( 'is-active', index === activeIndex );
				pill.setAttribute( 'aria-pressed', String( index === activeIndex ) );
			} );
		};

		teamPills.forEach( ( pill, index ) => {
			pill.addEventListener( 'click', ( event ) => {
				event.preventDefault();
				setFilter( index === activeIndex ? null : index );
			} );
		} );

		setFilter();
	} );
};

const normalizeCampaignDonationHash = () => {
	if ( '#campaign-donation' !== window.location.hash ) {
		return;
	}

	window.history.replaceState( null, '', `${ window.location.pathname }${ window.location.search }#donate` );
};

const initCampaignFormCelebrations = () => {
	const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' );

	const createHeartBurst = ( origin ) => {
		if ( prefersReducedMotion.matches ) {
			return;
		}

		const burst = document.createElement( 'span' );
		const heartCount = 14;

		burst.className = 'campaign-heart-burst';
		burst.setAttribute( 'aria-hidden', 'true' );
		burst.style.left = `${ origin.x }px`;
		burst.style.top = `${ origin.y }px`;

		for ( let index = 0; index < heartCount; index++ ) {
			const heart = document.createElement( 'span' );
			const angle = ( Math.PI * 2 * index ) / heartCount + ( Math.random() - .5 ) * .65;
			const distance = 180 + Math.random() * 280;

			heart.className = 'campaign-heart-burst__heart';
			heart.textContent = '♥';
			heart.style.setProperty( '--heart-x', `${ Math.cos( angle ) * distance }px` );
			heart.style.setProperty( '--heart-y', `${ Math.sin( angle ) * distance }px` );
			heart.style.setProperty( '--heart-rotate', `${ ( Math.random() - .5 ) * 50 }deg` );
			heart.style.setProperty( '--heart-delay', `${ Math.random() * 220 }ms` );
			burst.append( heart );
		}

		document.body.append( burst );
		window.setTimeout( () => burst.remove(), 2200 );
	};

	const createConfettiBurst = ( origin ) => {
		if ( prefersReducedMotion.matches ) {
			return;
		}

		const burst = document.createElement( 'span' );
		const colors = [ '#f97316', '#eab308', '#22c55e', '#3b82f6', '#ec4899', '#8b5cf6' ];
		const confettiCount = 28;

		burst.className = 'campaign-confetti-burst';
		burst.setAttribute( 'aria-hidden', 'true' );
		burst.style.left = `${ origin.x }px`;
		burst.style.top = `${ origin.y }px`;

		for ( let index = 0; index < confettiCount; index++ ) {
			const confetti = document.createElement( 'span' );

			confetti.className = 'campaign-confetti-burst__piece';
			confetti.style.setProperty( '--confetti-color', colors[ index % colors.length ] );
			confetti.style.setProperty( '--confetti-x', `${ ( Math.random() - .5 ) * 460 }px` );
			confetti.style.setProperty( '--confetti-y', `${ -150 - Math.random() * 280 }px` );
			confetti.style.setProperty( '--confetti-rotate', `${ ( Math.random() - .5 ) * 900 }deg` );
			confetti.style.setProperty( '--confetti-delay', `${ Math.random() * 180 }ms` );
			burst.append( confetti );
		}

		document.body.append( burst );
		window.setTimeout( () => burst.remove(), 2200 );
	};

	document.addEventListener( 'click', ( event ) => {
		if ( !( event.target instanceof Element ) ) {
			return;
		}

		const button = event.target.closest( 'button[id^="gform_submit_button_"], input[id^="gform_submit_button_"]' );

		if ( ! button || ! button.closest( '.campaign-donation-form' ) ) {
			const participationForm = button?.closest( '.akf-gf-participation-form' );

			if ( ! participationForm ) {
				return;
			}

			const rect = button.getBoundingClientRect();

			createConfettiBurst( {
				x: event.clientX || rect.left + rect.width / 2,
				y: event.clientY || rect.top + rect.height / 2,
			} );

			return;
		}

		const rect = button.getBoundingClientRect();

		createHeartBurst( {
			x: event.clientX || rect.left + rect.width / 2,
			y: event.clientY || rect.top + rect.height / 2,
		} );
	} );
};

const initCampaignDonationModal = () => {
	let column = document.querySelector( '.campaign-donation-column' );

	if ( ! column && document.body.classList.contains( 'single-akf_participant' ) ) {
		const card = document.querySelector( '.campaign-donation-card' );
		const grid = card?.closest( '.is-layout-grid' );
		column = [ ...( grid?.children || [] ) ].find( ( child ) => child.contains( card ) ) || null;

		if ( column ) {
			column.classList.add( 'campaign-donation-column' );
			column.id = 'donate';
		}
	}

	const card = column?.querySelector( '.campaign-donation-card' );

	if ( ! column || ! card ) {
		return;
	}

	const stack = column.querySelector( ':scope > .is-position-sticky' ) || column.firstElementChild;
	const originalParent = column.parentElement;
	const originalNextSibling = column.nextElementSibling;
	const originalOrder = [ ...stack.children ];
	const mobileQuery = window.matchMedia( '(max-width: 781px)' );
	const backdrop = document.createElement( 'button' );
	const cardShadow = document.createElement( 'div' );
	const closeButton = document.createElement( 'button' );
	let isOpen = false;
	let originalBodyStyles = null;
	let scrollPosition = 0;
	let returnFocus = null;
	let inertElements = [];

	backdrop.className = 'swv-modal-backdrop campaign-donation-backdrop';
	backdrop.type = 'button';
	backdrop.setAttribute( 'aria-label', column.dataset.closeLabel );
	backdrop.hidden = true;
	cardShadow.className = 'campaign-donation-shadow';
	cardShadow.setAttribute( 'aria-hidden', 'true' );
	closeButton.className = 'campaign-modal-close';
	closeButton.type = 'button';
	closeButton.setAttribute( 'aria-label', column.dataset.closeLabel );
	closeButton.textContent = '×';
	column.prepend( closeButton );
	column.tabIndex = -1;
	document.body.append( cardShadow, backdrop );
	stack.classList.add( 'campaign-modal-content' );
	column.classList.add( 'swv-modal--mobile-slide-up' );

	const syncCardShadow = () => {
		if ( ! mobileQuery.matches || ! isOpen ) {
			cardShadow.hidden = true;

			return;
		}

		const rect = card.getBoundingClientRect();
		cardShadow.hidden = false;
		Object.assign( cardShadow.style, {
			left: `${ rect.left }px`,
			top: `${ rect.top }px`,
			width: `${ rect.width }px`,
			height: `${ rect.height }px`,
			borderRadius: getComputedStyle( card ).borderRadius,
			boxShadow: getComputedStyle( card ).boxShadow,
		} );
	};

	const wantsOpen = () => {
		const hash = window.location.hash;

		return hash === '#donate' || ( /^#gf_\\d+$/.test( hash )
			&& !! column.querySelector( `#gform_${ hash.slice( 4 ) }` ) );
	};

	const setOpen = ( nextOpen ) => {
		if ( isOpen === nextOpen ) {
			return;
		}

		isOpen = nextOpen;
		if ( isOpen ) {
			scrollPosition = window.scrollY;
			returnFocus = document.activeElement;
			originalBodyStyles = {
				position: document.body.style.position,
				top: document.body.style.top,
				left: document.body.style.left,
				right: document.body.style.right,
				width: document.body.style.width,
			};
			Object.assign( document.body.style, {
				position: 'fixed', top: `-${ scrollPosition }px`, left: '0', right: '0', width: '100%',
			} );
			inertElements = [ ...document.body.children ].filter( ( element ) =>
				element !== column && element !== backdrop && ! element.inert
				&& ! [ 'SCRIPT', 'STYLE', 'LINK' ].includes( element.tagName )
			);
			inertElements.forEach( ( element ) => { element.inert = true; } );
			stack.scrollTop = 0;
		}

		document.body.classList.toggle( 'has-campaign-donation-modal', isOpen );
		document.documentElement.classList.toggle( 'has-campaign-donation-modal', isOpen );
		column.classList.toggle( 'is-modal-open', isOpen );
		column.inert = ! isOpen;
		backdrop.hidden = ! isOpen;
		syncCardShadow();

		if ( isOpen ) {
			return;
		}

		inertElements.forEach( ( element ) => { element.inert = false; } );
		inertElements = [];
		Object.assign( document.body.style, originalBodyStyles );
		originalBodyStyles = null;
		window.scrollTo( { top: scrollPosition, behavior: 'instant' } );
		if ( returnFocus?.isConnected ) {
			returnFocus.focus( { preventScroll: true } );
		}
	};

	const sync = () => {
		if ( mobileQuery.matches ) {
			// Finish all layout changes while hidden, before applying the animation.
			if ( column.parentElement !== document.body ) {
				document.body.append( column );
				const trust = stack.querySelector( '.campaign-donation-trust' );
				if ( trust ) {
					stack.insertBefore( trust, card );
				}
				const activity = stack.querySelector( '.campaign-activity-swiper' );
				if ( activity ) {
					stack.append( activity );
				}
			}
			column.setAttribute( 'role', 'dialog' );
			column.setAttribute( 'aria-modal', 'true' );
			column.setAttribute( 'aria-label', column.dataset.modalLabel );
			column.inert = ! isOpen;
			setOpen( wantsOpen() );
			window.requestAnimationFrame( syncCardShadow );

			return;
		}

		setOpen( false );
		column.inert = false;
		column.removeAttribute( 'role' );
		column.removeAttribute( 'aria-modal' );
		column.removeAttribute( 'aria-label' );
		if ( column.parentElement !== originalParent ) {
			originalParent.insertBefore( column, originalNextSibling?.parentElement === originalParent ? originalNextSibling : null );
			originalOrder.forEach( ( element ) => {
				if ( element.parentElement === stack ) {
					stack.append( element );
				}
			} );
		}
	};

	const handleLocation = () => {
		normalizeCampaignDonationHash();
		sync();
		if ( ! mobileQuery.matches && wantsOpen() ) {
			document.dispatchEvent( new CustomEvent( 'samenwerk:align-fragment-target', { detail: { target: card } } ) );
		}
	};
	const close = () => {
		const url = new URL( window.location.href );
		url.hash = '';
		window.history.replaceState( window.history.state, '', url );
		sync();
	};

	closeButton.addEventListener( 'click', close );
	backdrop.addEventListener( 'click', close );
	stack.addEventListener( 'scroll', syncCardShadow, { passive: true } );
	window.addEventListener( 'resize', syncCardShadow );
	document.addEventListener( 'click', ( event ) => {
		const donateButton = event.target.closest( '.nav-primary-navigation .donate, .nav-primary-navigation .donate a' );

		if ( donateButton && event.button === 0 && ! event.metaKey && ! event.ctrlKey
			&& ! event.shiftKey && ! event.altKey ) {
			event.preventDefault();
			if ( window.location.hash !== '#donate' ) {
				const url = new URL( window.location.href );
				url.hash = 'donate';
				window.history.pushState( window.history.state, '', url );
			}
			handleLocation();

			return;
		}

		const link = event.target.closest( 'a[href]' );
		if ( ! link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey
			|| event.shiftKey || event.altKey || link.hasAttribute( 'download' )
			|| ( link.target && link.target !== '_self' ) ) {
			return;
		}

		const url = new URL( link.href, window.location.href );
		if ( url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search
			|| ! [ '#donate', '#campaign-donation' ].includes( url.hash ) ) {
			return;
		}

		event.preventDefault();
		if ( window.location.hash !== '#donate' ) {
			url.hash = 'donate';
			window.history.pushState( window.history.state, '', url );
		}
		handleLocation();
	} );

	document.addEventListener( 'keydown', ( event ) => {
		if ( ! isOpen ) {
			return;
		}
		if ( event.key === 'Escape' ) {
			event.preventDefault();
			close();

			return;
		}
		if ( event.key !== 'Tab' ) {
			return;
		}

		const focusable = [ ...column.querySelectorAll( 'a[href], button, input, select, textarea, [tabindex]' ) ]
			.filter( ( element ) => ! element.disabled && element.tabIndex >= 0 && element.getClientRects().length
				&& ! element.closest( '[inert]' ) && getComputedStyle( element ).visibility !== 'hidden' );
		const first = focusable[ 0 ];
		const last = focusable.at( -1 );
		if ( event.shiftKey && document.activeElement === first ) {
			event.preventDefault();
			last?.focus( { preventScroll: true } );
		} else if ( ! event.shiftKey && document.activeElement === last ) {
			event.preventDefault();
			first?.focus( { preventScroll: true } );
		}
	} );

	mobileQuery.addEventListener( 'change', handleLocation );
	window.addEventListener( 'hashchange', handleLocation );
	window.addEventListener( 'popstate', handleLocation );
	window.addEventListener( 'pageshow', handleLocation );
	handleLocation();
};

const initCampaignDonationTrust = () => {
	const column = document.querySelector( '.campaign-donation-column' );

	if ( ! column ) {
		return;
	}

	let trust = column.querySelector( '.campaign-donation-trust' );

	if ( ! trust ) {
		trust = document.createElement( 'div' );
		trust.className = 'campaign-donation-trust';
		trust.setAttribute( 'aria-label', 'Veilig doneren' );

		const anbiLink = document.createElement( 'a' );
		anbiLink.className = 'campaign-donation-anbi';
		anbiLink.href = '/anbi/';
		anbiLink.setAttribute( 'aria-label', 'Bekijk onze ANBI-informatie' );

		const anbiLogo = document.createElement( 'img' );
		anbiLogo.alt = 'ANBI';
		anbiLogo.src = window.samenwerkMedia?.anbiLogo || '';

		const anbiText = document.createElement( 'span' );
		anbiText.textContent = 'Erkende ANBI, gift kan aftrekbaar zijn';

		anbiLink.append( anbiLogo, anbiText );

		const payment = document.createElement( 'div' );
		payment.className = 'campaign-donation-trust__item campaign-donation-payment';

		const paymentMethod = document.createElement( 'div' );
		paymentMethod.className = 'campaign-donation-payment__method';

		const paymentLogo = document.createElement( 'img' );
		paymentLogo.alt = 'iDEAL | Wero';
		paymentLogo.src = '/wp-content/uploads/2025/06/ideal-wero.svg';

		const paymentText = document.createElement( 'span' );
		paymentText.textContent = 'Veilig betalen via je bank';

		paymentMethod.append( paymentLogo, paymentText );
		payment.append( paymentMethod );

		anbiLink.classList.add( 'campaign-donation-trust__item' );
		trust.append( anbiLink, payment );

		const card = column.querySelector( '.campaign-donation-card' );
		const activity = column.querySelector( '.campaign-activity-swiper' );
		const parent = card?.parentElement || column;
		parent.insertBefore( trust, activity || null );
	}

	column.querySelector( '.campaign-donation-processor' )?.remove();

	const form = column.querySelector( 'form[id^="gform_"]' );
	const secondPage = form?.querySelector( '[id^="gform_page_"][id$="_2"]' );
	const footer = secondPage?.querySelector( '.gform_page_footer' );
	const submit = footer?.querySelector( '[id^="gform_submit_button_"]' );

	if ( ! footer || ! submit || footer.querySelector( '.campaign-donation-stripe' ) ) {
		return;
	}

	const stripe = document.createElement( 'div' );
	stripe.className = 'campaign-donation-stripe';

	const stripeLogo = document.createElement( 'img' );
	stripeLogo.alt = 'Stripe';
	stripeLogo.src = '/wp-content/uploads/2025/04/powered-by-stripe-purple.svg';
	stripe.append( stripeLogo );
	submit.after( stripe );
};

const initCampaignDonationTrustEvents = () => {
	if ( ! window.jQuery ) {
		return;
	}

	window.jQuery( document ).on( 'gform_page_loaded.campaignDonationTrust', () => {
		initCampaignDonationTrust();
	} );
};

const initCampaignPage = () => {
	normalizeCampaignDonationHash();
	initTeamFilters();
	initCampaignFormCelebrations();
	initCampaignDonationTrust();
	initCampaignDonationModal();
	initCampaignDonationTrustEvents();
};

if ( 'loading' === document.readyState ) {
	document.addEventListener( 'DOMContentLoaded', initCampaignPage );
} else {
	initCampaignPage();
}
